"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeKey = exports.retrieveKey = exports.adjustKeys = exports.parseNumberi18Format = exports.removeCommasNumber = exports.removeElement = exports.getLabel = exports.databaseDateFormat = exports.displayDate = exports.formatNumber = exports.getError = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const dayjs_1 = __importDefault(require("dayjs"));
const react_native_config_1 = __importDefault(require("react-native-config"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const crashlytics_1 = __importDefault(require("./crashlytics/crashlytics"));
const { PhoneNumberFormat, PhoneNumberUtil } = require('google-libphonenumber');
const phoneUtil = PhoneNumberUtil.getInstance();
const getError = (field, object) => {
    // maybe we'll need to improve this, now just getting the first error in the list
    if (object && field in object) {
        return object[field][0];
    }
    return null;
};
exports.getError = getError;
const formatNumber = (number) => {
    if (number)
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '0';
};
exports.formatNumber = formatNumber;
const displayDate = (date) => {
    dayjs_1.default.extend(customParseFormat_1.default);
    return (0, dayjs_1.default)(date, 'YYYY-MM-DD', true).format('DD-MM-YYYY');
};
exports.displayDate = displayDate;
const databaseDateFormat = (date) => {
    dayjs_1.default.extend(customParseFormat_1.default);
    return (0, dayjs_1.default)(date, 'DD-MM-YYYY', true).format('YYYY-MM-DD');
};
exports.databaseDateFormat = databaseDateFormat;
const getLabel = (choices, value) => {
    const choice = choices.find((obj) => obj.value === value);
    if (choice !== undefined) {
        return choice.label;
    }
    return '';
};
exports.getLabel = getLabel;
const removeElement = (el, arr) => {
    const index = arr.findIndex((i) => i === el);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
};
exports.removeElement = removeElement;
const removeCommasNumber = (number) => {
    if (typeof number === 'string')
        return parseInt(number.replace(/[.,\s]/g, ''), 10);
    return number;
};
exports.removeCommasNumber = removeCommasNumber;
const parseNumberi18Format = (phoneNumber) => {
    try {
        const number = phoneUtil.parseAndKeepRawInput(phoneNumber, react_native_config_1.default.COUNTRY_CODE);
        return phoneUtil.format(number, PhoneNumberFormat.E164);
    }
    catch (e) {
        return phoneNumber;
    }
};
exports.parseNumberi18Format = parseNumberi18Format;
// Storage keys
exports.adjustKeys = {
    adjust: 'adjust@app',
};
// Storage retrieve key
const retrieveKey = (key) => {
    return async_storage_1.default.getItem(key)
        .then((value) => {
        if (value)
            return JSON.parse(value);
        return null;
    })
        .catch((err) => {
        (0, crashlytics_1.default)(err);
        return null;
    });
};
exports.retrieveKey = retrieveKey;
// Storage store key
const storeKey = (key, value) => {
    return (0, exports.retrieveKey)(key).then((data) => {
        const newValue = { ...data, ...value };
        return async_storage_1.default.setItem(key, JSON.stringify(newValue)).catch((err) => {
            (0, crashlytics_1.default)(err);
            return err;
        });
    });
};
exports.storeKey = storeKey;
